import React from 'react'
import InputSearch from './InputSearch'
import DateFilter from "./DateFilter"
import moment from "moment";
import {getLocalData, setLocalData} from "../../../../services/StorageServices";

function ListCustomersFilters(props) {
    const {filters, setFiltersState} = props

    const _handleChangeInput = (name, value) => {
        const newState = {
            [name]: value
        }
        const listCustomersFilters = getLocalData('listCustomersFilters')
        setFiltersState(newState)
        const newStateLocal = {...listCustomersFilters, ...newState}
        setLocalData('listCustomersFilters', newStateLocal)
    }

    return <div className="CallHistoryFilters Filters">
        <div className="itemFilter mb-3">
            <InputSearch
                label="Người tạo"
                name="createdBy"
                value={filters.createdBy || ''}
                onChange={_handleChangeInput}
            />
        </div>
        <div className="itemFilter mb-3">
            <DateFilter
                label="Thời gian tạo (từ)"
                name="createDateFrom"
                value={moment(filters.createDateFrom, 'HH:mm DD/MM/YYYY')}
                showTime={true}
                onChangeDate={_handleChangeInput}
            />
        </div>
        <div className="itemFilter mb-3">
            <DateFilter
                label="Thời gian tạo (đến)"
                name="createDateTo"
                value={moment(filters.createDateTo, 'HH:mm DD/MM/YYYY')}
                format="HH:mm DD/MM/YYYY"
                showTime={true}
                onChangeDate={_handleChangeInput}
            />
        </div>
    </div>
}

export default ListCustomersFilters
